import {useAuth} from './AuthContext'
import { Loader2 } from 'lucide-react';
import { Navigate } from "react-router-dom";
import WorkSessionTimerWidget from "../work-session/WorkSessionTimerWidget";

const PrivateRouter = ({children}) => {

    const {user, isLoading} = useAuth()

    if (isLoading) {
        return (
            <div className="min-h-screen bg-[#12131a] flex items-center justify-center px-6">
                <div className="flex flex-col items-center gap-4 rounded-2xl border border-white/10 bg-white/5 px-8 py-6 shadow-[0_20px_60px_rgba(0,0,0,0.35)] backdrop-blur-sm">
                    <Loader2 className="h-8 w-8 animate-spin text-blue-400" />
                </div>
            </div>
        );
    }
    return user && user.email ? (
        <>
            {children}
            <WorkSessionTimerWidget/>
        </>
    ) : <Navigate to='/signin' replace/>
}

export default PrivateRouter